<div class="header">
  <h2>Pilot Final Disciplinary Actions</h2>
  <button mat-raised-button (click)="add()">
    <mat-icon>add</mat-icon> <span>Add Final Disciplinary Action</span>
  </button>
  <button mat-raised-button (click)="refresh()">
    <mat-icon>refresh</mat-icon>
  </button>
</div>
<div>
  <ng-template
    [flLoading]="loadingKey"
    [flLoadingUntil]="finalDisciplinaryActions$ | async"
    flLoadingStrategy="overlay"
    flLoadingColor="primary"
  >
    <table mat-table [dataSource]="finalDisciplinaryActions$" fxFlex="100">
      <ng-container matColumnDef="actionDate">
        <th mat-header-cell *matHeaderCellDef>Action Date</th>
        <td mat-cell *matCellDef="let finalDisciplinaryAction">
          {{ finalDisciplinaryAction.actionDate | date : 'MM/dd/yyyy' }}
        </td>
      </ng-container>
      <ng-container matColumnDef="actionType">
        <th mat-header-cell *matHeaderCellDef>Action Type</th>
        <td mat-cell *matCellDef="let finalDisciplinaryAction">
          {{ getActionTypeDescription(finalDisciplinaryAction.actionType) }}
        </td>
      </ng-container>
      <ng-container matColumnDef="removalFromOperations">
        <th mat-header-cell *matHeaderCellDef>Removal From Operations</th>
        <td mat-cell *matCellDef="let finalDisciplinaryAction">
          {{ finalDisciplinaryAction.removalFromOperations ? 'Yes' : 'No' }}
        </td>
      </ng-container>
      <ng-container matColumnDef="relevantDocuments">
        <th mat-header-cell *matHeaderCellDef>Relevant Documents</th>
        <td mat-cell *matCellDef="let finalDisciplinaryAction">
          {{ finalDisciplinaryAction.relevantDocuments ? 'Yes' : 'No' }}
        </td>
      </ng-container>
      <ng-container matColumnDef="processingState">
        <th mat-header-cell *matHeaderCellDef>Processing State</th>
        <td mat-cell *matCellDef="let finalDisciplinaryAction">
          {{ finalDisciplinaryAction.processingState | humanize }}
        </td>
      </ng-container>
      <ng-container matColumnDef="processingError">
        <th mat-header-cell *matHeaderCellDef>Processing Error</th>
        <td mat-cell *matCellDef="let finalDisciplinaryAction" class="prd-processing-error-text">
          {{ finalDisciplinaryAction.processingError }}
        </td>
      </ng-container>
      <ng-container matColumnDef="lastProcessedDate">
        <th mat-header-cell *matHeaderCellDef>Last Processed Date</th>
        <td mat-cell *matCellDef="let finalDisciplinaryAction">
          {{ (finalDisciplinaryAction.lastProcessedDate | date : 'MM/dd/yyyy HH:mm') || '--' }}
        </td>
      </ng-container>
      <ng-container matColumnDef="prdSourceSystemId">
        <th mat-header-cell *matHeaderCellDef>PRD Source System Id</th>
        <td mat-cell *matCellDef="let finalDisciplinaryAction">
          {{ finalDisciplinaryAction.prdSourceSystemId }}
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let finalDisciplinaryAction">
          <button mat-icon-button [matMenuTriggerFor]="finalDisciplinaryActionActions">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #finalDisciplinaryActionActions="matMenu">
            <a mat-menu-item (click)="edit(finalDisciplinaryAction)">
              <mat-icon>edit</mat-icon>Edit
            </a>
            <a mat-menu-item (click)="delete(finalDisciplinaryAction.id)">
              <mat-icon>delete</mat-icon>Delete
            </a>
          </mat-menu>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </ng-template>
</div>
<div>
  <mat-paginator
    (page)="onPage($event)"
    [length]="total$ | async"
    [pageSize]="defaultPageSize"
    [pageSizeOptions]="pageSizeOptions"
  >
  </mat-paginator>
</div>
